import { render, staticRenderFns } from "./Favorites.vue?vue&type=template&id=5ed87466&"
import script from "./Favorites.vue?vue&type=script&lang=js&"
export * from "./Favorites.vue?vue&type=script&lang=js&"
import style0 from "./Favorites.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Favorites.vue"
export default component.exports